<template>
  <div id="document-content-view">
    <vs-sidebar
      class="items-no-padding"
      parent="#document-content-view"
      :click-not-close="false"
      :hidden-background="true"
      v-model="isSidebarActive"
      position-right
    >
      <document-content-info-view></document-content-info-view>
    </vs-sidebar>
    <div v-show="showActionBar">
      <document-actionbar></document-actionbar>
    </div>
    <div v-show="!showActionBar" class="p-2">
      <span class="px-4">
        {{ selectedSidebarText }}
      </span>
    </div>
    <div id="document-view" class="px-4 py-2">
      <div v-show="isGridStyle()">
        <document-grid-view></document-grid-view>
      </div>
      <div v-show="!isGridStyle()">
        <document-list-view></document-list-view>
      </div>
    </div>
  </div>
</template>


<script>
import { ColorMixin } from "@/mixins";
import { DOCUMENT_DISPLAY_TYPE } from "@/config/const";
import DocumentActionbar from "./components/actionbar/DocumentContentActionbar"
import DocumentGridView from "./components/DocumentContentGridView"
import DocumentListView from "./components/DocumentContentListView"
import DocumentContentInfoView from "./DocumentContentInfoView"

import { createNamespacedHelpers } from "vuex";

const {
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  mixins: [ColorMixin],
  components: {
    DocumentActionbar, DocumentGridView, DocumentListView, DocumentContentInfoView
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "selectedContentViewStyle",
      "isContentInfoSidebarActive",
      "documents",
      "showListCardPath",
      "selectedSidebarText",
    ]),
    isSidebarActive: {
      get () { return this.isContentInfoSidebarActive },
      set (val) { this.SET_CONTENT_INFO_SIDEBAR_ACTIVE(val) }
    },

    showActionBar () {
      return !this.showListCardPath
    },
  },
  watch: {
    isSidebarActive (val) {
      this.SET_CONTENT_INFO_SIDEBAR_ACTIVE(val)
    },
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_CONTENT_INFO_SIDEBAR_ACTIVE",
    ]),
    isGridStyle () {
      return this.selectedContentViewStyle === DOCUMENT_DISPLAY_TYPE.GRID
    },
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

#document-content-view {
  .vs-sidebar {
    max-width: 400px;
  }
}
</style>